import React, { useRef } from 'react'
import { components, constants } from 'cng-web-lib'
import { Grid, Card, Box } from '@material-ui/core'
import ACEHighwayManifestTranslationText from './../contexts/ACEHighwayManifestTranslationText'
import Alert from 'src/components/Alert'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const {
  button: { CngButton },
  form: { CngForm },
  CngDialog
} = components

const { FormState } = constants

function PopulatePaxlstDialog(props) {
  const { open, onClose, onPopulatePaxlstInfo, onCreateDefaultPaxlstEntry } = props

  const aceHighwayManifestTranslationText = ACEHighwayManifestTranslationText() 

  function handlePopulatePaxlstInfo() {
    onPopulatePaxlstInfo()
    onClose()
  }

  function handleCreateDefaultPaxlstEntry() {
    onCreateDefaultPaxlstEntry()
    onClose()
  }

  return (
    <CngDialog
      dialogContent={
        <Card variant='outlined'>
            <Box padding={2}>
                <Grid container alignItems='center' justify='space-between' spacing={3}>
                    <Grid item>                              
                        {aceHighwayManifestTranslationText.populatePAXLSTQuestion}
                    </Grid>                      
                </Grid>
                <Grid container alignItems='center' justify='space-between' spacing={3}>
                    <Grid item>                              
                        <Alert severity='info' icon={<FontAwesomeIcon icon={['fal', 'info-circle']} />}>
                            * {aceHighwayManifestTranslationText.populatePAXLSTNote}
                        </Alert>
                    </Grid>                      
                </Grid>                
                <Grid container alignItems='center' justify='space-between' spacing={3}>
                    <Grid item>                              
                        <CngButton
                        color='secondary'
                        onClick={() =>
                            handlePopulatePaxlstInfo()
                        }
                        size='medium'
                        >
                            {aceHighwayManifestTranslationText.populatePAXLSTButton}
                        </CngButton>  
                    </Grid>   
                    <Grid item>                              
                        <CngButton
                        color='secondary'
                        onClick={() =>
                            handleCreateDefaultPaxlstEntry()
                        }
                        size='medium'
                        >
                            {aceHighwayManifestTranslationText.skipButton}
                        </CngButton>  
                    </Grid>                                          
                </Grid>                
            </Box>
        </Card>
      }
      dialogTitle={aceHighwayManifestTranslationText.populatePAXLSTButton}
      fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
      fullWidth
      maxWidth='sm'
      onClose={onClose}
      open={open}
    />
  )
}

export default PopulatePaxlstDialog
